import * as React from "react";
import Modal from "../../../../ui/modal/Modal";
import SectionView from "../../../section/SectionView";
import Row from "../../../Row";
import Col from "../../../Col";
import AddHelpContactForm from "../AddHelpContactForm";

interface Props {
	/**
	 * On close action.
	 */
	onClose: () => void;
}

/**
 * Create contact modal view.
 */
export default class HelpContactModal extends React.PureComponent<Props, {}> {

	constructor(props: Props) {
		super(props);
		this.handleCloseModal = this.handleCloseModal.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.handleCloseModal} title={"Help"}>
				<SectionView>
					<Row>
						<Col>
							<span className={"t-body"}>
							Need help with Installer Platform? <br/>
							Please contact Hiber's product team so we can resolve your issue as quickly as possible.<br/>
							Call us: 0808 169 6484<br/>
							Email us: <a className={"t-link"} href={"mailto:installers@hiber.com"}>installers@hiber.com</a>
							</span>
						</Col>
					</Row>
				</SectionView>
				<AddHelpContactForm onCancel={this.handleCloseModal}/>
			</Modal>
		);
	}

	/**
	 * Handle close modal.
	 */
	private handleCloseModal() {
		this.props.onClose();
	}
}